import React, { useMemo } from 'react'

import CloseIconV2 from '../../../../../assets/CloseIconV2'
import SearchIcon from '../../../../../assets/SearchIcon'
import { UserHeaderIcon } from '../../../../../assets/UserHeaderIcon'
import { useClubContext } from '../../../../../contexts/ClubContext'
import { useStoreContext } from '../../../../../contexts/StoreContext'
import { useSession } from '../../../../../sdk/session'
import IconButton from '../../../../ui/IconButton'
import SearchInput from '../../../SearchInput'
import './mobile-navbar-header.scss'

type Callback = () => unknown

interface MobileNavbarHeaderProps {
  dismissTransition: React.MutableRefObject<Callback | undefined>
  setShowMenu: (showMenu: boolean) => void
}

export const MobileNavbarHeader = ({
  dismissTransition,
  setShowMenu,
}: MobileNavbarHeaderProps) => {
  const { secureSubdomain, loginUrl } = useStoreContext()
  const { person } = useSession()
  const { isClubClient, userInfos: clubUserInfos } = useClubContext()

  const userInfos = useMemo(() => {
    if (person) {
      return person
    }

    if (isClubClient) {
      return clubUserInfos
    }

    return undefined
  }, [clubUserInfos, person, isClubClient])

  return (
    <>
      <header className="mobile-navbar-header-container">
        <div className="mobile-navbar-header-user">
          <a
            className="mobile-navbar-header-interno"
            href={userInfos ? `${secureSubdomain}/api/io/account#/` : loginUrl}
          >
            <UserHeaderIcon />
            <div className="mobile-navbar-header-infos">
              <span>Bem Vindo</span>
              {userInfos ? (
                <p className="mobile-navbar-header-login">
                  {userInfos?.givenName && userInfos?.familyName
                    ? `${userInfos?.givenName} ${userInfos?.familyName}`
                    : userInfos?.email}
                </p>
              ) : (
                <p className="mobile-navbar-header-login">
                  Entrar na conta do site e clube
                </p>
              )}
            </div>
          </a>

          <IconButton
            classes="mobile-navbar-header-close"
            aria-label="Close Menu"
            icon={<CloseIconV2 color="var(--color-main)" />}
            onClick={() => dismissTransition.current?.()}
          />
        </div>
      </header>

      <div className="mobile-navbar-header-search">
        <div className="mobile-navbar-header-search-title">
          <span>Não encontrou algo?</span>
        </div>
        <SearchInput
          className="mobile-navbar-header-search-input"
          icon={<SearchIcon />}
          placeholder="Procure aqui"
          isMobileNavbar
          setShowMenu={setShowMenu}
        />
      </div>
    </>
  )
}
